import { render, staticRenderFns } from "./AanvullendeVragen.vue?vue&type=template&id=6c410f36"
import script from "./AanvullendeVragen.vue?vue&type=script&lang=ts"
export * from "./AanvullendeVragen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports